module.exports = __webpack_public_path__ + "img/zelenjava.3a2e6c6c.jpeg";